module.exports = __webpack_public_path__ + "static/media/page_03.bfc7d753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page_03.jpg
// module id = 1829
// module chunks = 0 1